import {Vanity} from "../../parts/vanity";
import VanityCommon from "./vanityCommon";
import {createParentPositions, LayoutAbbreviations, METADATA, VANITY_TYPES} from "../../constants";

export default class VanityBacksplash extends VanityCommon {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'vanity_backsplash';
    this.partName = 'Backsplash';
    this.translateId = "visualizer.bathroom.vanity.vanity_backsplash";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    this.isStoneFeature = true;
    if (isChild) {
      createParentPositions(this);
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityCabinet
      || !vanityParent.vanityCabinet.activeFeature
      || vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet
      || !vanityParent.vanityCabinet.activeFeature.metaData["MatchingFeature"].includes(METADATA.NO)
      || vanityParent.sink?.activeFeature?.metaData["Backsplash"] // ["disable"]
  }

}
